<button class="kz-diaporama-v2--fullscreen"
        [ngClass]="{'isFullScreen' : fullScreenIsOpened}"
        i18n-title="@@kazaplan-diaporama-fullscreen-title"
        title="Full screen mode">
  <kz-icons name="fullscreen" *ngIf="!fullScreenIsOpened"></kz-icons>
  <kz-icons name="cross" *ngIf="fullScreenIsOpened"></kz-icons>
</button>
